"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["onClick", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var styles = {
  "anypoint-styles": "styles__anypoint-styles__mTqSv",
  "toggle-button": "styles__toggle-button__3feKV",
  "anypointStyles": "styles__anypoint-styles__mTqSv",
  "toggleButton": "styles__toggle-button__3feKV"
}; 
require('./styles.css');
var displayName = 'Toggle';
var propTypes = {
  className: _propTypes["default"].string,
  onClick: _propTypes["default"].func
};
var defaultProps = {
  className: '',
  onClick: null
};
var Toggle = function Toggle(_ref) {
  var onClick = _ref.onClick,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("button", {
    onClick: onClick,
    className: styles.toggleButton,
    "data-test-id": "navbar-toggle-icon",
    title: "Products"
  }, /*#__PURE__*/_react["default"].createElement("lume-icon", _extends({}, props, {
    className: (0, _classnames["default"])(styles.toggle, className),
    set: "utility",
    symbol: "list"
  })));
};
Toggle.displayName = displayName;
Toggle.propTypes = propTypes;
Toggle.defaultProps = defaultProps;
var _default = exports["default"] = Toggle;
//# sourceMappingURL=Toggle.js.map